// extracted by mini-css-extract-plugin
export default {"title":"RedactUserComponent_title__IOaEW","btn_add_ser":"RedactUserComponent_btn_add_ser__YRRLy","btn_wrapper":"RedactUserComponent_btn_wrapper__PU0ZU"};